export default function canon(str = "") {
  return String(str).replace(/_entry$/i, "");
}

export function canonLower(str = "") {
  return canon(str).toLowerCase();
}

/* camel-case just lowers the leading capital so
   “ArticleLongform”  →  “articleLongform”          */
export const camelCase = (str = "") =>
  String(str).replace(/^[A-Z]/, m => m.toLowerCase());

export function canonCamelCase(str = "") {
  return canon(camelCase(str));
}

/* CSV-only normaliser:
     – camel-cases the raw EntryType column
     – adds “…Entries” for the two composable variants            */
export const normalizeEntryType = (raw = "") => {
  const camel = canon(camelCase(raw.trim()));

  switch (camel) {
    case "articleLongformComposable":
      return "articleLongformComposableEntries";
    case "articleStepByStepComposable":
      return "articleStepByStepComposableEntries";
    default:
      return camel;
  }
};
